import { useCallback } from "react";
import { useGetBIN } from "@/hooks/use-queries";
import { resolveCardStyle, type ApiBin } from "@/lib/card-style";

// Resolves a card's look from the live bin list (cached by react-query, so
// every card on screen shares one request). Until the bins arrive, a card is
// styled by its own network alone and updates once they load.
export function useCardStyle() {
  const { data: bins } = useGetBIN();
  return useCallback(
    (
      rawBin: string | number | null | undefined,
      network?: string,
      provider?: string,
    ) => resolveCardStyle(rawBin, network, (bins ?? []) as ApiBin[], provider),
    [bins],
  );
}
